import { useEffect, useState } from 'react';
import type { OpenApiSpec } from '@/lib/openapi/types';

const SPEC_URL = (import.meta.env.VITE_API_BASE_URL || 'https://api.satutim.id') + '/openapi.json';

interface Result {
    spec: OpenApiSpec | null;
    loading: boolean;
    error: string | null;
}

let cached: OpenApiSpec | null = null;

export function useOpenApi(): Result {
    const [spec, setSpec] = useState<OpenApiSpec | null>(cached);
    const [loading, setLoading] = useState(!cached);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (cached) return;
        let cancelled = false;
        setLoading(true);
        fetch(SPEC_URL)
            .then((r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data: OpenApiSpec) => {
                if (cancelled) return;
                cached = data;
                setSpec(data);
            })
            .catch((e) => { if (!cancelled) setError(e.message || 'Gagal memuat spec'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    return { spec, loading, error };
}
